import { getDefaultHeader } from '../services/serviceAPIHelper';
/**
 * Create a transfer availabilty request.
 * @param {Object} data 
 */
export const callAvailability = async function (data) {
    let url = process.env.REACT_APP_API_URL + 'transfers/availability';
    let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: getDefaultHeader(true)
    });
    if (response.ok) {
        const result = await response.json();
        window.localStorage.setItem(result.requestToken, JSON.stringify(result));
        return result;
    }
    else {
        const error = await response.json();
        throw error;
    }
};
/**
 * Return an availabilty result previously cached.
 * 
 * @param {String} token 
 */
export const getAvailability = async function (token, filters) {
    let url = process.env.REACT_APP_API_URL + 'transfers/availability/' + token;
    //http://{{api-endpoint}}:{{api-port}}/v1/transfers/availability/{{requestToken}}
    let response = await fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    });
    if (response.ok) {
        const result = await response.json();
        return result;
    }
    else {
        const error = await response.json();
        throw error;
    }
};

export const callValuation = async function (valoration) {
    let url = process.env.REACT_APP_API_URL + 'transfers/valuation';

    let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(valoration),
        headers: getDefaultHeader(true)
    });
    if (response.ok) {
        return await response.json();
    }
    else {
        let error;
        try {
            error = await response.json();
        } catch (ee) {
            error = new Error('Unable to process transfers/valuation');
        }
        if (error) {
            throw error;
        }
    }
};

/**
 * Return a transfer valuation getValuation.
 * 
 * @param {String} token 
 */
export const getValuation = async function (token, filters) {
    let url = process.env.REACT_APP_API_URL + 'transfers/valuation/' + token;
    //http://{{api-endpoint}}:{{api-port}}/v1/transfers/valuation/{{requestToken}}
    let response = await fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    });
    if (response.ok) {
        const result = await response.json();
        return result;
    }
    else {
        const error = await response.json();
        throw error;
    }
};

/**
 * POST a reservation transfer request
 * 
 * @param {String} reservation 
 */
export const postReservation = async function (reservation, filters) {
    let url = process.env.REACT_APP_API_URL + 'transfers/reservation';
    //http://{{api-endpoint}}:{{api-port}}/v1/transfers/valuation/{{requestToken}}
    let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(reservation),
        headers: getDefaultHeader(true)
    });
    if (response.ok) {
        const result = await response.json();
        return result;
    }
    else {
        let error;
        try {
            error = await response.json();
        } catch (ee) {
            error = new Error('Unable to process reservation');
        }
        if (error) {
            throw error;
        }
    }
};


// WEBPACK FOOTER //
// ./src/services/transfersService.js